import { RESOURCE_URI } from 'shared/constants/global';
import { TaletsOfClassType } from 'shared/constants/talentsData';

export const paladin: TaletsOfClassType[] = [{
  title: 'holy',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/382.jpg`,
  icon: `${RESOURCE_URI}/icons/large/spell_holy_holybolt.jpg`,
  talents: [
    {
      id: 'paladin_holy_spiritual_focus',
      title: 'Spiritual Focus',
      description: {
        1: 'Reduces the pushback suffered from damaging attacks while casting Flash of Light and Holy Light by 14%.',
        2: 'Reduces the pushback suffered from damaging attacks while casting Flash of Light and Holy Light by 28%.',
        3: 'Reduces the pushback suffered from damaging attacks while casting Flash of Light and Holy Light by 42%.',
        4: 'Reduces the pushback suffered from damaging attacks while casting Flash of Light and Holy Light by 56%.',
        5: 'Reduces the pushback suffered from damaging attacks while casting Flash of Light and Holy Light by 70%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_arcane_blink.jpg`,
      tier: 1,
      column: 2,
      max: 5,
    },
    {
      id: 'paladin_holy_seals_of_the_pure',
      title: 'Seals of the Pure',
      description: {
        1: 'Increases the damage done by your Seal of Righteousness, Seal of Vengeance and Seal of Corruption and their Judgement effects by 3%.',
        2: 'Increases the damage done by your Seal of Righteousness, Seal of Vengeance and Seal of Corruption and their Judgement effects by 6%.',
        3: 'Increases the damage done by your Seal of Righteousness, Seal of Vengeance and Seal of Corruption and their Judgement effects by 9%.',
        4: 'Increases the damage done by your Seal of Righteousness, Seal of Vengeance and Seal of Corruption and their Judgement effects by 12%.',
        5: 'Increases the damage done by your Seal of Righteousness, Seal of Vengeance and Seal of Corruption and their Judgement effects by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_thunderbolt.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_holy_healing_light',
      title: 'Healing Light',
      description: {
        1: 'Increases the amount healed by your Holy Light, Flash of Light and the effectiveness of Holy Shock spells by 4%.',
        2: 'Increases the amount healed by your Holy Light, Flash of Light and the effectiveness of Holy Shock spells by 8%.',
        3: 'Increases the amount healed by your Holy Light, Flash of Light and the effectiveness of Holy Shock spells by 12%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_holybolt.jpg`,
      tier: 2,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_holy_divine_intellect',
      title: 'Divine Intellect',
      description: {
        1: 'Increases your total Intellect by 2%.',
        2: 'Increases your total Intellect by 4%.',
        3: 'Increases your total Intellect by 6%.',
        4: 'Increases your total Intellect by 8%.',
        5: 'Increases your total Intellect by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_sleep.jpg`,
      tier: 2,
      column: 2,
      max: 5,
    }, {
      id: 'paladin_holy_unyielding_faith',
      title: 'Unyielding Faith',
      description: {
        1: 'Reduces the duration of all Fear and Disorient effects by 15%.',
        2: 'Reduces the duration of all Fear and Disorient effects by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_unyieldingfaith.jpg`,
      tier: 2,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_holy_aura_mastery',
      title: 'Aura Mastery',
      description: {
        1: 'Causes your Concentration Aura to make all affected targets immune to Silence and Interrupt effects and improve the effect of all other auras by 100%. Lasts 6 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_auramastery.jpg`,
      tier: 3,
      column: 1,
      max: 1,
      cooldown: 120,
    }, {
      id: 'paladin_holy_illumination',
      title: 'Illumination',
      description: {
        1: 'After getting a critical effect from your Flash of Light, Holy Light, or Holy Shock heal spell you have a 20% chance to gain mana equal to 30% of the base cost of the spell.',
        2: 'After getting a critical effect from your Flash of Light, Holy Light, or Holy Shock heal spell you have a 40% chance to gain mana equal to 30% of the base cost of the spell.',
        3: 'After getting a critical effect from your Flash of Light, Holy Light, or Holy Shock heal spell you have a 60% chance to gain mana equal to 30% of the base cost of the spell.',
        4: 'After getting a critical effect from your Flash of Light, Holy Light, or Holy Shock heal spell you have a 80% chance to gain mana equal to 30% of the base cost of the spell.',
        5: 'After getting a critical effect from your Flash of Light, Holy Light, or Holy Shock heal spell you have a 100% chance to gain mana equal to 30% of the base cost of the spell.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_greaterheal.jpg`,
      tier: 3,
      column: 2,
      max: 5,
    }, {
      id: 'paladin_holy_improved_lay_on_hands',
      title: 'Improved Lay on Hands',
      description: {
        1: 'Grants the target of your Lay on Hands spell 10% reduced physical damage taken for 15 sec. In addition, the cooldown for your Lay on Hands spell is reduced by 2 min.',
        2: 'Grants the target of your Lay on Hands spell 20% reduced physical damage taken for 15 sec. In addition, the cooldown for your Lay on Hands spell is reduced by 4 min.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_layonhands.jpg`,
      tier: 3,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_holy_improved_concentration_aura',
      title: 'Improved Concentration Aura',
      description: {
        1: 'Increases the effect of your Concentration Aura by an additional 5% and while any Aura is active reduces the duration of any Silence or Interrupt effect used against an affected group member by 10%. The duration reduction does not stack with any other effects.',
        2: 'Increases the effect of your Concentration Aura by an additional 10% and while any Aura is active reduces the duration of any Silence or Interrupt effect used against an affected group member by 20%. The duration reduction does not stack with any other effects.',
        3: 'Increases the effect of your Concentration Aura by an additional 15% and while any Aura is active reduces the duration of any Silence or Interrupt effect used against an affected group member by 30%. The duration reduction does not stack with any other effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_mindsooth.jpg`,
      tier: 4,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_holy_improved_blessing_of_wisdom',
      title: 'Improved Blessing of Wisdom',
      description: {
        1: 'Increases the effect of your Blessing of Wisdom spell by 10%.',
        2: 'Increases the effect of your Blessing of Wisdom spell by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_sealofwisdom.jpg`,
      tier: 4,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_holy_blessed_hands',
      title: 'Blessed Hands',
      description: {
        1: 'Reduces the mana cost of Hand of Freedom, Hand of Sacrifice and Hand of Salvation by 15%, increases the effectiveness of Hand of Salvation by 50% and the effectiveness of Hand of Sacrifice by an additional 5%.',
        2: 'Reduces the mana cost of Hand of Freedom, Hand of Sacrifice and Hand of Salvation by 30%, increases the effectiveness of Hand of Salvation by 100% and the effectiveness of Hand of Sacrifice by an additional 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_blessedhands.jpg`,
      tier: 4,
      column: 4,
      max: 2,
    }, {
      id: 'paladin_holy_pure_of_heart',
      title: 'Pure of Heart',
      description: {
        1: 'Reduces the duration of Curse, Disease and Poison effects by 15%.',
        2: 'Reduces the duration of Curse, Disease and Poison effects by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_pureofheart.jpg`,
      tier: 5,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_holy_divine_favor',
      title: 'Divine Favor',
      description: {
        1: 'When activated, gives your next Flash of Light, Holy Light, or Holy Shock spell a 100% critical effect chance.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_heal.jpg`,
      tier: 5,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 120,
      costs: '3% of base mana',
      required: 'paladin_holy_illumination',
    }, {
      id: 'paladin_holy_sanctified_light',
      title: 'Sanctified Light',
      description: {
        1: 'Increases the critical effect chance of your Holy Light and Holy Shock spells by 2%.',
        2: 'Increases the critical effect chance of your Holy Light and Holy Shock spells by 4%.',
        3: 'Increases the critical effect chance of your Holy Light and Holy Shock spells by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_healingaura.jpg`,
      tier: 5,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_holy_purifying_power',
      title: 'Purifying Power',
      description: {
        1: 'Reduces the mana cost of your Cleanse, Purify and Consecration spells by 5% and reduces the cooldown of your Exorcism and Holy Wrath spells by 17%.',
        2: 'Reduces the mana cost of your Cleanse, Purify and Consecration spells by 10% and reduces the cooldown of your Exorcism and Holy Wrath spells by 33%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_purifyingpower.jpg`,
      tier: 6,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_holy_holy_power',
      title: 'Holy Power',
      description: {
        1: 'Increases the critical effect chance of your Holy spells by 1%.',
        2: 'Increases the critical effect chance of your Holy spells by 2%.',
        3: 'Increases the critical effect chance of your Holy spells by 3%.',
        4: 'Increases the critical effect chance of your Holy spells by 4%.',
        5: 'Increases the critical effect chance of your Holy spells by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_power.jpg`,
      tier: 6,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_holy_lights_grace',
      title: 'Light\'s Grace',
      description: {
        1: 'Gives your Holy Light spell a 33% chance to reduce the cast time of your next Holy Light spell by 0.5 sec. This effect lasts 15 sec.',
        2: 'Gives your Holy Light spell a 66% chance to reduce the cast time of your next Holy Light spell by 0.5 sec. This effect lasts 15 sec.',
        3: 'Gives your Holy Light spell a 100% chance to reduce the cast time of your next Holy Light spell by 0.5 sec. This effect lasts 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_lightsgrace.jpg`,
      tier: 7,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_holy_holy_shock',
      title: 'Holy Shock',
      description: {
        1: 'Blasts the target with Holy energy, causing 314 to 340 Holy damage to an enemy, or 481 to 519 healing to an ally.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_searinglight.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 6,
      costs: '18% of base mana',
      range: 20,
      required: 'paladin_holy_divine_favor',
    }, {
      id: 'paladin_holy_blessed_life',
      title: 'Blessed Life',
      description: {
        1: 'All attacks against you have a 4% chance to cause half damage.',
        2: 'All attacks against you have a 7% chance to cause half damage.',
        3: 'All attacks against you have a 10% chance to cause half damage.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_blessedlife.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_holy_sacred_cleansing',
      title: 'Sacred Cleansing',
      description: {
        1: 'Your Cleanse spell has a 10% chance to increase the target\'s resistance to Disease, Magic and Poison by 30% for 10 sec.',
        2: 'Your Cleanse spell has a 20% chance to increase the target\'s resistance to Disease, Magic and Poison by 30% for 10 sec.',
        3: 'Your Cleanse spell has a 30% chance to increase the target\'s resistance to Disease, Magic and Poison by 30% for 10 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_sacredcleansing.jpg`,
      tier: 8,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_holy_holy_guidance',
      title: 'Holy Guidance',
      description: {
        1: 'Increases your spell power by 4% of your total Intellect.',
        2: 'Increases your spell power by 8% of your total Intellect.',
        3: 'Increases your spell power by 12% of your total Intellect.',
        4: 'Increases your spell power by 16% of your total Intellect.',
        5: 'Increases your spell power by 20% of your total Intellect.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_holyguidance.jpg`,
      tier: 8,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_holy_divine_illumination',
      title: 'Divine Illumination',
      description: {
        1: 'Reduces the mana cost of all spells by 50% for 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_divineillumination.jpg`,
      tier: 9,
      column: 1,
      max: 1,
    }, {
      id: 'paladin_holy_judgements_of_the_pure',
      title: 'Judgements of the Pure',
      description: {
        1: 'Increases the damage done by your Seal and Judgement spells by 5%, and your Judgement spells increase your casting and melee haste by 3% for 1 min.',
        2: 'Increases the damage done by your Seal and Judgement spells by 10%, and your Judgement spells increase your casting and melee haste by 6% for 1 min.',
        3: 'Increases the damage done by your Seal and Judgement spells by 15%, and your Judgement spells increase your casting and melee haste by 9% for 1 min.',
        4: 'Increases the damage done by your Seal and Judgement spells by 20%, and your Judgement spells increase your casting and melee haste by 12% for 1 min.',
        5: 'Increases the damage done by your Seal and Judgement spells by 25%, and your Judgement spells increase your casting and melee haste by 15% for 1 min.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_judgementofthepure.jpg`,
      tier: 9,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_holy_infusion_of_light',
      title: 'Infusion of Light',
      description: {
        1: 'Your Holy Shock critical hits reduce the cast time of your next Flash of Light by 0.75 sec or increase the critical chance of your next Holy Light by 10%. In addition, causes your Flash of Light to heal targets with Sacred Shield for an additional 50% over 12 sec.',
        2: 'Your Holy Shock critical hits reduce the cast time of your next Flash of Light by 1.5 sec or increase the critical chance of your next Holy Light by 20%. In addition, causes your Flash of Light to heal targets with Sacred Shield for an additional 100% over 12 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_infusionoflight.jpg`,
      tier: 10,
      column: 2,
      max: 2,
      required: 'paladin_holy_holy_shock',
    }, {
      id: 'paladin_holy_enlightened_judgements',
      title: 'Enlightened Judgements',
      description: {
        1: 'Increases the range of your Judgement of Light and Judgement of Wisdom spells by 15 yards and increases your chance to hit by 2%.',
        2: 'Increases the range of your Judgement of Light and Judgement of Wisdom spells by 30 yards and increases your chance to hit by 4%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_enlightenedjudgements.jpg`,
      tier: 10,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_holy_beacon_of_light',
      title: 'Beacon of Light',
      description: {
        1: 'The target becomes a Beacon of Light to all members of your party or raid within a 60 yard radius. Any heals you cast on party or raid members will also heal the Beacon for 100% of the amount healed. Only one target can be the Beacon of Light at a time. Lasts 1 min.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_beaconoflight.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      castDuration: 'instant',
      costs: '35% of base mana',
      range: 60,
    },
  ],
}, {
  title: 'protection',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/383.jpg`,
  icon: `${RESOURCE_URI}/icons/large/spell_holy_devotionaura.jpg`,
  talents: [
    {
      id: 'paladin_protection_divinity',
      title: 'Divinity',
      description: {
        1: 'Increases all healing done by you and all healing effects on you by 1%.',
        2: 'Increases all healing done by you and all healing effects on you by 2%.',
        3: 'Increases all healing done by you and all healing effects on you by 3%.',
        4: 'Increases all healing done by you and all healing effects on you by 4%.',
        5: 'Increases all healing done by you and all healing effects on you by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_blindingheal.jpg`,
      tier: 1,
      column: 2,
      max: 5,
    }, {
      id: 'paladin_protection_divine_strength',
      title: 'Divine Strength',
      description: {
        1: 'Increases your total Strength by 3%.',
        2: 'Increases your total Strength by 6%.',
        3: 'Increases your total Strength by 9%.',
        4: 'Increases your total Strength by 12%.',
        5: 'Increases your total Strength by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_golemthunderclap.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_protection_stoicism',
      title: 'Stoicism',
      description: {
        1: 'Reduces the duration of all Stun effects by an additional 10% and reduces the chance your helpful spells and damage over time effects will be dispelled by an additional 10%.',
        2: 'Reduces the duration of all Stun effects by an additional 20% and reduces the chance your helpful spells and damage over time effects will be dispelled by an additional 20%.',
        3: 'Reduces the duration of all Stun effects by an additional 30% and reduces the chance your helpful spells and damage over time effects will be dispelled by an additional 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_stoicism.jpg`,
      tier: 2,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_protection_guardians_favor',
      title: 'Guardian\'s Favor',
      description: {
        1: 'Reduces the cooldown of your Hand of Protection by 60 sec and increases the duration of your Hand of Freedom by 2 sec.',
        2: 'Reduces the cooldown of your Hand of Protection by 2 min and increases the duration of your Hand of Freedom by 4 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_sealofprotection.jpg`,
      tier: 2,
      column: 2,
      max: 2,
    }, {
      id: 'paladin_protection_anticipation',
      title: 'Anticipation',
      description: {
        1: 'Increases your chance to dodge by 1%.',
        2: 'Increases your chance to dodge by 2%.',
        3: 'Increases your chance to dodge by 3%.',
        4: 'Increases your chance to dodge by 4%.',
        5: 'Increases your chance to dodge by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_magic_lesserinvisibilty.jpg`,
      tier: 2,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_protection_divine_sacrifice',
      title: 'Divine Sacrifice',
      description: {
        1: '30% of all damage taken by party members within 30 yards is redirected to the Paladin (up to a maximum of 40% of the Paladin\'s health times the number of party members). Damage which reduces the Paladin below 20% health will break the effect. Lasts 10 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_powerwordbarrier.jpg`,
      tier: 3,
      column: 1,
      max: 1,
      castDuration: 'instant',
      cooldown: 120,
    }, {
      id: 'paladin_protection_improved_righteous_fury',
      title: 'Improved Righteous Fury',
      description: {
        1: 'While Righteous Fury is active, all damage taken is reduced by 2%.',
        2: 'While Righteous Fury is active, all damage taken is reduced by 4%.',
        3: 'While Righteous Fury is active, all damage taken is reduced by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_sealoffury.jpg`,
      tier: 3,
      column: 2,
      max: 3,
    }, {
      id: 'paladin_protection_toughness',
      title: 'Toughness',
      description: {
        1: 'Increases your armor value from items by 2% and reduces the duration of all movement slowing effects by 6%.',
        2: 'Increases your armor value from items by 4% and reduces the duration of all movement slowing effects by 12%.',
        3: 'Increases your armor value from items by 6% and reduces the duration of all movement slowing effects by 18%.',
        4: 'Increases your armor value from items by 8% and reduces the duration of all movement slowing effects by 24%.',
        5: 'Increases your armor value from items by 10% and reduces the duration of all movement slowing effects by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_devotion.jpg`,
      tier: 3,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_protection_divine_guardian',
      title: 'Divine Guardian',
      description: {
        1: 'When Divine Sacrifice is activated, your party and raid members within 30 yards take 10% reduced damage for 6 sec. In addition, increases the duration of your Sacred Shield by 50% and the amount absorbed by 10%.',
        2: 'When Divine Sacrifice is activated, your party and raid members within 30 yards take 20% reduced damage for 6 sec. In addition, increases the duration of your Sacred Shield by 100% and the amount absorbed by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_powerwordbarrier.jpg`,
      tier: 4,
      column: 1,
      max: 2,
      required: 'paladin_protection_divine_sacrifice',
    }, {
      id: 'paladin_protection_improved_hammer_of_justice',
      title: 'Improved Hammer of Justice',
      description: {
        1: 'Decreases the cooldown of your Hammer of Justice spell by 10 sec.',
        2: 'Decreases the cooldown of your Hammer of Justice spell by 20 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_sealofmight.jpg`,
      tier: 4,
      column: 2,
      max: 2,
    }, {
      id: 'paladin_protection_improved_devotion_aura',
      title: 'Improved Devotion Aura',
      description: {
        1: 'Increases the armor bonus of your Devotion Aura by 17% and increases the amount healed on any target affected by any of your Auras by 2%.',
        2: 'Increases the armor bonus of your Devotion Aura by 34% and increases the amount healed on any target affected by any of your Auras by 4%.',
        3: 'Increases the armor bonus of your Devotion Aura by 50% and increases the amount healed on any target affected by any of your Auras by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_devotionaura.jpg`,
      tier: 4,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_protection_blessing_of_sanctuary',
      title: 'Blessing of Sanctuary',
      description: {
        1: 'Places a Blessing on the friendly target, reducing damage taken from all sources by 3% for 10 min and increasing strength and stamina by 10%. In addition, when the target blocks, parries, or dodges a melee attack the target will gain 2% of maximum displayed mana. Players may only have one Blessing on them per Paladin at any one time.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_lightningshield.jpg`,
      tier: 5,
      column: 2,
      max: 1,
      castDuration: 'instant',
      costs: '7% of base mana',
      range: 30,
    }, {
      id: 'paladin_protection_reckoning',
      title: 'Reckoning',
      description: {
        1: 'Gives you a 2% chance after blocking or being hit by any damaging attack that the next 4 weapon swings within 8 sec will generate an additional attack.',
        2: 'Gives you a 4% chance after blocking or being hit by any damaging attack that the next 4 weapon swings within 8 sec will generate an additional attack.',
        3: 'Gives you a 6% chance after blocking or being hit by any damaging attack that the next 4 weapon swings within 8 sec will generate an additional attack.',
        4: 'Gives you a 8% chance after blocking or being hit by any damaging attack that the next 4 weapon swings within 8 sec will generate an additional attack.',
        5: 'Gives you a 10% chance after blocking or being hit by any damaging attack that the next 4 weapon swings within 8 sec will generate an additional attack.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_blessingofstrength.jpg`,
      tier: 5,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_protection_sacred_duty',
      title: 'Sacred Duty',
      description: {
        1: 'Increases your total Stamina by 2%, reduces the cooldown of your Divine Shield and Divine Protection spells by 30 sec.',
        2: 'Increases your total Stamina by 4%, reduces the cooldown of your Divine Shield and Divine Protection spells by 60 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_divineintervention.jpg`,
      tier: 6,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_protection_one_handed_weapon_specialization',
      title: 'One-Handed Weapon Specialization',
      description: {
        1: 'Increases all damage you deal when a one-handed melee weapon is equipped by 4%.',
        2: 'Increases all damage you deal when a one-handed melee weapon is equipped by 7%.',
        3: 'Increases all damage you deal when a one-handed melee weapon is equipped by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_sword_20.jpg`,
      tier: 6,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_protection_spiritual_attunement',
      title: 'Spiritual Attunement',
      description: {
        1: 'A passive ability that gives the Paladin mana when healed by other friendly targets\' spells. The amount of mana gained is equal to 5% of the amount healed.',
        2: 'A passive ability that gives the Paladin mana when healed by other friendly targets\' spells. The amount of mana gained is equal to 10% of the amount healed.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_revivechampion.jpg`,
      tier: 7,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_protection_holy_shield',
      title: 'Holy Shield',
      description: {
        1: 'Increases chance to block by 30% for 10 sec and deals 79 Holy damage for each attack blocked while active. Each block expends a charge. 8 charges.',
      },
      icon: `${RESOURCE_URI}/icons/large/classic_spell_holy_blessingofprotection.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 8,
      costs: '8% of base mana',
      required: 'paladin_protection_blessing_of_sanctuary',
    }, {
      id: 'paladin_protection_ardent_defender',
      title: 'Ardent Defender',
      description: {
        1: 'Damage that takes you below 35% health is reduced by 7%. In addition, attacks which would otherwise kill you cause you to be healed by up to 10% of your maximum health (amount healed based on defense). This healing effect cannot occur more often than once every 2 min.',
        2: 'Damage that takes you below 35% health is reduced by 13%. In addition, attacks which would otherwise kill you cause you to be healed by up to 20% of your maximum health (amount healed based on defense). This healing effect cannot occur more often than once every 2 min.',
        3: 'Damage that takes you below 35% health is reduced by 20%. In addition, attacks which would otherwise kill you cause you to be healed by up to 30% of your maximum health (amount healed based on defense). This healing effect cannot occur more often than once every 2 min.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_ardentdefender.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_protection_redoubt',
      title: 'Redoubt',
      description: {
        1: 'Increases your block value by 10% and damaging melee and ranged attacks against you have a 10% chance to increase your chance to block by 10%. Lasts 10 sec or 5 blocks.',
        2: 'Increases your block value by 20% and damaging melee and ranged attacks against you have a 10% chance to increase your chance to block by 20%. Lasts 10 sec or 5 blocks.',
        3: 'Increases your block value by 30% and damaging melee and ranged attacks against you have a 10% chance to increase your chance to block by 30%. Lasts 10 sec or 5 blocks.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_defend.jpg`,
      tier: 8,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_protection_combat_expertise',
      title: 'Combat Expertise',
      description: {
        1: 'Increases your expertise by 2, total Stamina and chance to critically hit by 2%.',
        2: 'Increases your expertise by 4, total Stamina and chance to critically hit by 4%.',
        3: 'Increases your expertise by 6, total Stamina and chance to critically hit by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_weaponmastery.jpg`,
      tier: 8,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_protection_touched_by_the_light',
      title: 'Touched by the Light',
      description: {
        1: 'Increases your spell power by an amount equal to 20% of your Strength and increases the amount healed by your critical heals by 10%.',
        2: 'Increases your spell power by an amount equal to 40% of your Strength and increases the amount healed by your critical heals by 20%.',
        3: 'Increases your spell power by an amount equal to 60% of your Strength and increases the amount healed by your critical heals by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_touchedbylight.jpg`,
      tier: 9,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_protection_avengers_shield',
      title: 'Avenger\'s Shield',
      description: {
        1: 'Hurls a holy shield at the enemy, dealing (440 + 0.07 * Spell power + 0.07 * Attack power) to (536 + 0.07 * Spell power + 0.07 * Attack power) Holy damage, Dazing them and then jumping to additional nearby enemies. Affects 3 total targets. Lasts 10 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_avengersshield.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 30,
      costs: '26% of base mana',
      range: 30,
      required: 'paladin_protection_holy_shield',
    }, {
      id: 'paladin_protection_guarded_by_the_light',
      title: 'Guarded by the Light',
      description: {
        1: 'Reduces spell damage taken by 3% and gives a 50% chance to refresh the duration of your Divine Plea when you hit an enemy. In addition, your Divine Plea spell is 50% less likely to be dispelled.',
        2: 'Reduces spell damage taken by 6% and gives a 100% chance to refresh the duration of your Divine Plea when you hit an enemy. In addition, your Divine Plea spell is 100% less likely to be dispelled.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_gaurdedbythelight.jpg`,
      tier: 9,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_protection_shield_of_the_templar',
      title: 'Shield of the Templar',
      description: {
        1: 'Reduces all damage taken by 1% and grants your Avenger\'s Shield a 33% chance to silence your targets for 3 sec.',
        2: 'Reduces all damage taken by 2% and grants your Avenger\'s Shield a 66% chance to silence your targets for 3 sec.',
        3: 'Reduces all damage taken by 3% and grants your Avenger\'s Shield a 100% chance to silence your targets for 3 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_shieldofthetemplar.jpg`,
      tier: 10,
      column: 2,
      max: 3,
      required: 'paladin_protection_avengers_shield',
    }, {
      id: 'paladin_protection_judgements_of_the_just',
      title: 'Judgements of the Just',
      description: {
        1: 'Reduces the cooldown of your Hammer of Justice by 5 sec, increases the duration of your Seal of Justice effect by 0.5 sec and your Judgement spells also reduce the melee attack speed of the target by 10%.',
        2: 'Reduces the cooldown of your Hammer of Justice by 10 sec, increases the duration of your Seal of Justice effect by 1 sec and your Judgement spells also reduce the melee attack speed of the target by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_judgementsofthejust.jpg`,
      tier: 10,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_protection_hammer_of_the_righteous',
      title: 'Hammer of the Righteous',
      description: {
        1: 'Hammer the current target and up to 2 additional nearby targets, causing 4 times your main hand damage per second as Holy damage.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_hammeroftherighteous.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 6,
      costs: '6% of base mana',
      range: 0,
    },
  ],
}, {
  title: 'retribution',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/381.jpg`,
  icon: `${RESOURCE_URI}/icons/large/spell_holy_auraoflight.jpg`,
  talents: [
    {
      id: 'paladin_retribution_deflection',
      title: 'Deflection',
      description: {
        1: 'Increases your Parry chance by 1%.',
        2: 'Increases your Parry chance by 2%.',
        3: 'Increases your Parry chance by 3%.',
        4: 'Increases your Parry chance by 4%.',
        5: 'Increases your Parry chance by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_parry.jpg`,
      tier: 1,
      column: 2,
      max: 5,
    }, {
      id: 'paladin_retribution_benediction',
      title: 'Benediction',
      description: {
        1: 'Reduces the mana cost of all instant cast spells by 2%.',
        2: 'Reduces the mana cost of all instant cast spells by 4%.',
        3: 'Reduces the mana cost of all instant cast spells by 6%.',
        4: 'Reduces the mana cost of all instant cast spells by 8%.',
        5: 'Reduces the mana cost of all instant cast spells by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_frost_windwalkon.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    }, {
      id: 'paladin_retribution_improved_judgements',
      title: 'Improved Judgements',
      description: {
        1: 'Decreases the cooldown of your Judgement spells by 1 sec.',
        2: 'Decreases the cooldown of your Judgement spells by 2 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_righteousfury.jpg`,
      tier: 2,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_retribution_heart_of_the_crusader',
      title: 'Heart of the Crusader',
      description: {
        1: 'In addition to the normal effect, your Judgement spells will also increase the critical strike chance of all attacks made against that target by an additional 1%.',
        2: 'In addition to the normal effect, your Judgement spells will also increase the critical strike chance of all attacks made against that target by an additional 2%.',
        3: 'In addition to the normal effect, your Judgement spells will also increase the critical strike chance of all attacks made against that target by an additional 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_holysmite.jpg`,
      tier: 2,
      column: 2,
      max: 3,
    }, {
      id: 'paladin_retribution_improved_blessing_of_might',
      title: 'Improved Blessing of Might',
      description: {
        1: 'Increases the attack power bonus of your Blessing of Might by 12%.',
        2: 'Increases the attack power bonus of your Blessing of Might by 25%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_fistofjustice.jpg`,
      tier: 2,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_retribution_vindication',
      title: 'Vindication',
      description: {
        1: 'Gives the Paladin\'s damaging attacks a chance to reduce the target\'s attack power by 287 for 10 sec.',
        2: 'Gives the Paladin\'s damaging attacks a chance to reduce the target\'s attack power by 574 for 10 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_vindication.jpg`,
      tier: 3,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_retribution_conviction',
      title: 'Conviction',
      description: {
        1: 'Increases your chance to get a critical strike with all spells and attacks by 1%.',
        2: 'Increases your chance to get a critical strike with all spells and attacks by 2%.',
        3: 'Increases your chance to get a critical strike with all spells and attacks by 3%.',
        4: 'Increases your chance to get a critical strike with all spells and attacks by 4%.',
        5: 'Increases your chance to get a critical strike with all spells and attacks by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_retributionaura.jpg`,
      tier: 3,
      column: 2,
      max: 5,
    }, {
      id: 'paladin_retribution_seal_of_command',
      title: 'Seal of Command',
      description: {
        1: 'All melee attacks deal (0.36 * Mainhand weapon min damage) to (0.36 * Mainhand weapon max damage) additional Holy damage. When used with attacks or abilities that strike a single target, this additional Holy damage will strike up to 2 additional targets. Lasts 30 min. Unleashing this Seal\'s energy will judge an enemy, instantly causing (0.19 * Mainhand weapon min damage + 0.08 * Attack power + 0.13 * Spell power) to (0.19 * Mainhand weapon max damage + 0.08 * Attack power + 0.13 * Spell power) Holy damage.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_innerrage.jpg`,
      tier: 3,
      column: 3,
      max: 1,
      costs: '14% of base mana',
      castDuration: 'instant',
    }, {
      id: 'paladin_retribution_pursuit_of_justice',
      title: 'Pursuit of Justice',
      description: {
        1: 'Reduces the duration of all Disarm effects by 8% and increases movement and mounted movement speed by 8%. This does not stack with other movement speed increasing effects.',
        2: 'Reduces the duration of all Disarm effects by 15% and increases movement and mounted movement speed by 15%. This does not stack with other movement speed increasing effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_persuitofjustice.jpg`,
      tier: 3,
      column: 4,
      max: 2,
    }, {
      id: 'paladin_retribution_eye_for_an_eye',
      title: 'Eye for an Eye',
      description: {
        1: 'All criticals against you cause 5% of the damage taken to the attacker as well. The damage caused by Eye for an Eye will not exceed 50% of the Paladin\'s total health.',
        2: 'All criticals against you cause 10% of the damage taken to the attacker as well. The damage caused by Eye for an Eye will not exceed 100% of the Paladin\'s total health.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_eyeforaneye.jpg`,
      tier: 4,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_retribution_sanctity_of_battle',
      title: 'Sanctity of Battle',
      description: {
        1: 'Increases your chance to critically hit with all spells and attacks by 1% and increases the damage caused by Exorcism and Crusader Strike by 5%.',
        2: 'Increases your chance to critically hit with all spells and attacks by 2% and increases the damage caused by Exorcism and Crusader Strike by 10%.',
        3: 'Increases your chance to critically hit with all spells and attacks by 3% and increases the damage caused by Exorcism and Crusader Strike by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_holysmite.jpg`,
      tier: 4,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_retribution_crusade',
      title: 'Crusade',
      description: {
        1: 'Increases all damage caused by 1% and all damage caused against Humanoids, Demons, Undead and Elementals by an additional 1%.',
        2: 'Increases all damage caused by 2% and all damage caused against Humanoids, Demons, Undead and Elementals by an additional 2%.',
        3: 'Increases all damage caused by 3% and all damage caused against Humanoids, Demons, Undead and Elementals by an additional 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_crusade.jpg`,
      tier: 4,
      column: 4,
      max: 3,
    }, {
      id: 'paladin_retribution_two_handed_weapon_specialization',
      title: 'Two-Handed Weapon Specialization',
      description: {
        1: 'Increases the damage you deal with two-handed melee weapons by 2%.',
        2: 'Increases the damage you deal with two-handed melee weapons by 4%.',
        3: 'Increases the damage you deal with two-handed melee weapons by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_hammer_04.jpg`,
      tier: 5,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_retribution_sanctified_retribution',
      title: 'Sanctified Retribution',
      description: {
        1: 'Increases the damage caused by Retribution Aura by 50% and all damage caused by friendly targets affected by any of your Auras is increased by 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_mindvision.jpg`,
      tier: 5,
      column: 3,
      max: 1,
    }, {
      id: 'paladin_retribution_vengeance',
      title: 'Vengeance',
      description: {
        1: 'Gives you a 1% bonus to Physical and Holy damage you deal for 30 sec after dealing a critical strike from a weapon swing, spell, or ability. This effect stacks up to 3 times.',
        2: 'Gives you a 2% bonus to Physical and Holy damage you deal for 30 sec after dealing a critical strike from a weapon swing, spell, or ability. This effect stacks up to 3 times.',
        3: 'Gives you a 3% bonus to Physical and Holy damage you deal for 30 sec after dealing a critical strike from a weapon swing, spell, or ability. This effect stacks up to 3 times.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_racial_avatar.jpg`,
      tier: 6,
      column: 2,
      max: 3,
      required: 'paladin_retribution_conviction',
    }, {
      id: 'paladin_retribution_divine_purpose',
      title: 'Divine Purpose',
      description: {
        1: 'Reduces your chance to be hit by spells and ranged attacks by 2% and gives your Hand of Freedom spell a 50% chance to remove any Stun effects on the target.',
        2: 'Reduces your chance to be hit by spells and ranged attacks by 4% and gives your Hand of Freedom spell a 100% chance to remove any Stun effects on the target.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_divinepurpose.jpg`,
      tier: 6,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_retribution_the_art_of_war',
      title: 'The Art of War',
      description: {
        1: 'Increases the damage of your Judgement, Crusader Strike and Divine Storm abilities by 5% and when your melee attacks critically hit the cast time of your next Flash of Light or Exorcism is reduced by 0.75 sec.',
        2: 'Increases the damage of your Judgement, Crusader Strike and Divine Storm abilities by 10% and when your melee attacks critically hit your next Flash of Light or Exorcism spell becomes instant cast.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_artofwar.jpg`,
      tier: 7,
      column: 1,
      max: 2,
    }, {
      id: 'paladin_retribution_repentance',
      title: 'Repentance',
      description: {
        1: 'Puts the enemy target in a state of meditation, incapacitating them for up to 1 min, and removing the effect of Righteous Vengeance. Any damage caused will awaken the target. Usable against Demons, Dragonkin, Giants, Humanoids and Undead.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_prayerofhealing.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 60,
      costs: '16% of base mana',
      range: 20,
    }, {
      id: 'paladin_retribution_judgements_of_the_wise',
      title: 'Judgements of the Wise',
      description: {
        1: 'Your damaging Judgement spells have a 33% chance to grant the Replenishment effect to up to 10 party or raid members mana regeneration equal to 1% of their maximum mana per 5 sec for 15 sec, and to immediately grant you 25% of your base mana.',
        2: 'Your damaging Judgement spells have a 66% chance to grant the Replenishment effect to up to 10 party or raid members mana regeneration equal to 1% of their maximum mana per 5 sec for 15 sec, and to immediately grant you 25% of your base mana.',
        3: 'Your damaging Judgement spells have a 100% chance to grant the Replenishment effect to up to 10 party or raid members mana regeneration equal to 1% of their maximum mana per 5 sec for 15 sec, and to immediately grant you 25% of your base mana.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_judgementofthewise.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_retribution_fanaticism',
      title: 'Fanaticism',
      description: {
        1: 'Increases the critical strike chance of all Judgements capable of a critical hit by 6% and reduces threat caused by all actions by 10% except when under the effects of Righteous Fury.',
        2: 'Increases the critical strike chance of all Judgements capable of a critical hit by 12% and reduces threat caused by all actions by 20% except when under the effects of Righteous Fury.',
        3: 'Increases the critical strike chance of all Judgements capable of a critical hit by 18% and reduces threat caused by all actions by 30% except when under the effects of Righteous Fury.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_fanaticism.jpg`,
      tier: 8,
      column: 2,
      max: 3,
      required: 'paladin_retribution_repentance',
    }, {
      id: 'paladin_retribution_sanctified_wrath',
      title: 'Sanctified Wrath',
      description: {
        1: 'Increases the critical strike chance of Hammer of Wrath by 25%, reduces the cooldown of Avenging Wrath by 30 secs and while affected by Avenging Wrath 25% of all damage caused bypasses damage reduction effects.',
        2: 'Increases the critical strike chance of Hammer of Wrath by 50%, reduces the cooldown of Avenging Wrath by 60 secs and while affected by Avenging Wrath 50% of all damage caused bypasses damage reduction effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_sanctifiedwrath.jpg`,
      tier: 8,
      column: 3,
      max: 2,
    }, {
      id: 'paladin_retribution_swift_retribution',
      title: 'Swift Retribution',
      description: {
        1: 'Your auras also increase casting, ranged and melee attack speeds by 1%.',
        2: 'Your auras also increase casting, ranged and melee attack speeds by 2%.',
        3: 'Your auras also increase casting, ranged and melee attack speeds by 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_swiftretribution.jpg`,
      tier: 9,
      column: 1,
      max: 3,
    }, {
      id: 'paladin_retribution_crusader_strike',
      title: 'Crusader Strike',
      description: {
        1: 'An instant strike that causes 75% weapon damage.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_crusaderstrike.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 4,
      costs: '5% of base mana',
      range: 0,
    }, {
      id: 'paladin_retribution_sheath_of_light',
      title: 'Sheath of Light',
      description: {
        1: 'Increases your spell power by an amount equal to 10% of your attack power and your critical healing spells heal the target for 20% of the healed amount over 12 seconds.',
        2: 'Increases your spell power by an amount equal to 20% of your attack power and your critical healing spells heal the target for 40% of the healed amount over 12 seconds.',
        3: 'Increases your spell power by an amount equal to 30% of your attack power and your critical healing spells heal the target for 60% of the healed amount over 12 seconds.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_sheathoflight.jpg`,
      tier: 9,
      column: 3,
      max: 3,
    }, {
      id: 'paladin_retribution_righteous_vengeance',
      title: 'Righteous Vengeance',
      description: {
        1: 'When your Judgement, Crusader Strike and Divine Storm spells deal a critical strike, your target will take 10% additional damage over 8 sec.',
        2: 'When your Judgement, Crusader Strike and Divine Storm spells deal a critical strike, your target will take 20% additional damage over 8 sec.',
        3: 'When your Judgement, Crusader Strike and Divine Storm spells deal a critical strike, your target will take 30% additional damage over 8 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_righteousvengeance.jpg`,
      tier: 10,
      column: 2,
      max: 3,
    }, {
      id: 'paladin_retribution_divine_storm',
      title: 'Divine Storm',
      description: {
        1: 'An instant weapon attack that causes 110% of weapon damage to up to 4 enemies within 8 yards. The Divine Storm heals up to 3 party or raid members totaling 25% of the damage caused.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_paladin_divinestorm.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 10,
      costs: '12% of base mana',
    },
  ],
}];
